// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UpgradePlanWarningV5 = require("../common/Components/UpgradePlanWarningV5.bs.js");

function PropertyPage__FreePlanUpgradeBox(props) {
  return JsxRuntime.jsx(UpgradePlanWarningV5.Warning.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: "Full property information is only available to Pro TAN Members:",
              className: "font-medium"
            }),
            JsxRuntime.jsx("p", {
              children: "If you want to learn more about any property, including the address, listing agent and other details, you need to upgrade to the Pro Plan."
            })
          ],
          className: "flex flex-col gap-4"
        }),
        JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          href: "/subscribe",
          children: "Upgrade to PRO"
        })
      ],
      className: "flex flex-col gap-8 items-center"
    })
  });
}

let make = PropertyPage__FreePlanUpgradeBox;

exports.make = make;
/* ButtonsV5 Not a pure module */
